import { FC } from 'react';
import stepIcon from '../../../Assets/StepIcons/Sub.png';
import { NodeLibraryListItem } from '../../Components/NodeLibraryListItem';
import { NodeTypes, SUBPLAY_NODE_DESCRIPTION } from '../../utils';

export const SubplayNodeLibraryListItem: FC = () => {
    return <NodeLibraryListItem label='Subplay' description={SUBPLAY_NODE_DESCRIPTION} nodeType={NodeTypes.SUBPLAY} imgPath={stepIcon} />
}